import {
  DELETE_MIXTURE_REQUEST,
  DELETE_MIXTURE_ERROR,
  DELETE_MIXTURE_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_MIXTURE_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_MIXTURE_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_MIXTURE_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixture";
  context.entityLocation = RESOURCES.Mixtures;

  return context.execute(context)(entity)(state, action);
};

